import echarts from 'echarts/lib/echarts';
import React from 'react';
import { uuidDate, copy } from 'rt-sd-common/sgiCommon/sgiCommon';
import { sgiLogger } from 'rt-sd-common/sgiCommon/sgiLogger';
import { ObjFactory } from 'rt-sd-common/sgiFactory/ObjFactory';
import SgiComponent from "../sgiBaseComp/SgiComponent";
import { SgiEventHandler } from '../SgiEventHandler';
import { getConstByKey, setFunction } from '../sgiBaseComp/SgiCommon';

export default class SgiEChartsComponent extends SgiComponent {

    constructor(props) {
        super(props);
        this.state = {
            ...this.state,
            uuid: uuidDate(6, "yyyyMMddhhmmssSSS"),
            data: this.props.data || [],
            echartsProps: { style: { width: "100%", height: "100%" } },
            option: {},
            originalOption: {},
            getOption: () => ({ title: "" }),
            eventName: "", // 事件名称，全小写，例如'click'，'mousemove', 'legendselected'
            query: "", // 可选的过滤条件，能够只在指定的组件或者元素上进行响应。可为 string 或者 Object。
            // getOn: () => ({}),
            functions: {},
            chart:null,
            reload: false
        };
    }

    _maker(parentModule, moduleDesc, objFct, type) {
        super._maker(parentModule, moduleDesc, objFct, type);

        // 校验描述
        if (!moduleDesc) {
            return;
        }

        // 转换ctn公共属性
        addCtnCommonAttribute(this, moduleDesc, this.state.echartsProps);
        // 转换公共属性
        this.addEchartsCommonAttribute(moduleDesc, this.state.echartsProps, this.state.option, parentModule, objFct, type);
        // 转换各图表基础属性
        this.AddAttribute(moduleDesc, this.state.echartsProps, this.state.option, parentModule, objFct, type);
    }

    /**
     * 属性转换
     * @param {object} moduleDesc 
     * @param {object} echartsProps 
     * @param {object} option 
     * @param {object} parentModule 
     * @param {ObjFactory} objFct 
     * @param {string} type 
     */
    addEchartsCommonAttribute(moduleDesc, echartsProps, option, parentModule, objFct, type) {
        // 取data
        const bdInst = getConstByKey(this, moduleDesc.bdInst);
        this.state.insName = bdInst;
        if (bdInst && objFct) {
            this.state.data = objFct.get(bdInst) || [];
        }

        // 自定义option
        let getOption = moduleDesc.option;
        let $getOption;
        if (getOption) {
            try {
                $getOption = new Function("module", "data", "objFct", getOption);
            } catch (error) {
                sgiLogger.eventErr(error);
            }
            this.state.getOption = $getOption;
        }

        // 鼠标事件相关
        const eventName = moduleDesc.eventName;
        this.state.eventName = eventName ? eventName : "click";
        const query = moduleDesc.query;
        if (query) {
            try {
                this.state.query = JSON.parse(query);
            } catch (error) {
                this.state.query = query;
            }
        }

    }

    refreshByData(data, reload) {
        data = data || [];
        this.setState({ data, reload });
    }

    refresh = () => {
        this.loaded = false;
        this.setState({ loading: false });
    }

    //渲染并返回一个虚拟DOM
    render = function () {

        const { parentModule, moduleDesc, objFct, type } = this.props;

        if (!this.loaded) {
            //组装属性
            this._maker(parentModule, moduleDesc, objFct, type);
            this.loaded = true;
        }

        this.reGetOption(objFct, type);

        return <div id={this.state.uuid} {...this.state.echartsProps} />
    }

    reGetOption(objFct, type) {
        let originalOption = this.state.originalOption || {};
        this.state.option = originalOption;
        if (type !== "dnd") {
            let cstmOption = this.state.getOption(this, this.state.data, objFct);
            this.state.option = merge(copy(originalOption, true), cstmOption);
        }
    }

    reSetOption() {
        setTimeout(() => {
            let chart = echarts.init(document.getElementById(this.state.uuid), this.props.moduleDesc.theme || "light");
            let notMerge = false;
            if (this.state.reload) {
                chart.clear();
                this.state.reload = false;
                notMerge = true;
            }
            chart.setOption(this.state.option, notMerge);
            this.state.chart=chart;

            //绑定事件
            this.bindEvent(this.props.moduleDesc, chart, this.state.getOn, this.state.functions, this.props.type);

        }, 0);
    }

    bindEvent(moduleDesc, chart, getOn, functions, type) {
        //拖拽模式 不生成事件
        var getOn = moduleDesc.on; // 用户自定义点击事件
        if (getOn && type != 'dnd') {
            var $on;
            try {
                $on = new Function("module", "data", "seriesName", "objFct", "params", getOn);
            } catch (error) {
                sgiLogger.eventErr(error);
            }

            functions.getOn = $on;
        }
        if (this.state.query) {
            chart.on(this.state.eventName, this.state.query, SgiEventHandler.eChartsEvent.bind(this));
        } else {
            chart.on(this.state.eventName, SgiEventHandler.eChartsEvent.bind(this));
        }

    }

    componentDidMount() {
        this.reSetOption();
    }
    componentDidUpdate() {
        this.reSetOption();
    }

    // 子类实现各处理方法
    // 添加各自属性
    AddAttribute() { }

}

/**
 * 属性合并
 * @param {object} target 目标对象
 * @param {object} source 源对象
 */
function merge(target, source) {
    // 目标和源相同，直接返回
    if (target === source) return target;
    // 分情况处理
    if (Object.prototype.toString.call(target) === '[object Object]' && Object.prototype.toString.call(source) === '[object Object]') {
        for (let key in source) {
            if (target[key] === source[key]) continue;//相同，跳过
            if (!target[key]) target[key] = source[key];//target属性不存在，直接赋值
            else target[key] = merge(target[key], source[key]);//target属性存在，合并
        }
    } else if (Object.prototype.toString.call(target) === '[object Array]' && Object.prototype.toString.call(source) === '[object Array]') {
        for (let i = 0; i < source.length; i++) {
            if (target[i] === source[i]) continue;//相同，跳过
            if (!target[i]) target.push(source[i]);//target元素不存在，直接添加
            else target[i] = merge(target[i], source[i]);//target元素存在，合并
        }
    } else {//其他情况，直接赋值
        target = source;
    }
    // 返回target
    return target;

}


/**
 * 转换ctn公共属性（不参与继承，所以放外面）
 * @param {object} currentModule 当前module
 * @param {object} moduleDesc json描述
 * @param {object} ctnWrapProps ctn容器属性
 * @param {object} ctnHeadProps ctnhead属性
 * @param {object} ctnBodyProps ctnbody属性
 */
function addCtnCommonAttribute(currentModule, moduleDesc, ctnWrapProps, ctnHeadProps, ctnBodyProps) {
    var cId = getConstByKey(currentModule, moduleDesc.cId); //cid 唯一标示
    if (cId) {
        ctnWrapProps.id = cId;
        currentModule.state.uuid = cId;
    }

    var ctlW = moduleDesc.ctlW; //容器宽度
    ctnWrapProps.style.width = ctlW;
    if (ctlW == 0 || ctlW == '0px') {
        ctnWrapProps.style.width = undefined;
    }

    var ctlH = moduleDesc.ctlH; //容器高度
    ctnWrapProps.style.height = ctlH;
    if (ctlH == 0 || ctlH == '0px') {
        ctnWrapProps.style.height = undefined;
    }

    var isBrdr = moduleDesc.isBrdr; //容器是否有边框??没实现
    if (isBrdr) {
        ctnWrapProps.style.border = "1px solid rgb(217, 217, 217)";/*边线宽度 类型 颜色*/;
    } else {
        ctnWrapProps.style.border = undefined;
    }

    var mgn = moduleDesc.mgn; //容器外边距
    if (mgn) ctnWrapProps.style.margin = mgn;
    var pad = moduleDesc.pad; //容器内边距
    if (pad) ctnWrapProps.style.padding = pad;

    var isHdn = moduleDesc.isHdn; //容器是否隐藏
    if (isHdn) {
        ctnWrapProps.style.display = "none";
    } else {
        ctnWrapProps.style.display = undefined;
    }

    var isScl = moduleDesc.isScl; //容器是否可以滚动
    if (isScl) {
        if (!ctnBodyProps) ctnWrapProps.style.overflow = "auto";
        if (ctnBodyProps) ctnBodyProps.style.overflow = "auto";
    } else {
        if (!ctnBodyProps) ctnWrapProps.style.overflow = undefined;
        if (ctnBodyProps) ctnBodyProps.style.overflow = undefined;
    }

    //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
    // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
    //     var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
    //     if (te) ctnProps.te = te;
    // }
    var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
    ctnWrapProps.te = te;

    // 初始加载中
    currentModule.state.loading = !!moduleDesc.loading;

    // 自定义样式
    let cstmStyle = moduleDesc.cstmStyle;
    let $cstmStyle;
    if (cstmStyle) {
        try {
            $cstmStyle = new Function("module", "objFct", cstmStyle);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        // currentModule.state.cstmStyle = $cstmStyle;
        setFunction(currentModule, "cstmStyle", $cstmStyle);
    }
}


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiECharts/SgiEChartsComponent.js